import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (appVersion) => {
  const data = new FormData();
  data.append('toast_clicked', appVersion);
  const p = new Promise((resolve, reject) => {
    Vue.$http
    .request({
      url: 'user-app-version/click-toast-msg',
      data,
      method: 'post',
    })
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/account/updateUserAppToast.js